import { IPinnedDashboard, IPinnedDashboardCollection } from 'wisestep-api';

export enum IPinnedEntityEnum {
  HOME = 'HOME',
  DASHBOARD_COLLECTION = 'DASHBOARD_COLLECTION',
  DASHBOARD = 'DASHBOARD',
  RECRUITER_ANALYTICS = 'RECRUITER_ANALYTICS',
}

export interface IPinnedEntities {
  collections: IPinnedDashboardCollection[];
  dashboards: IPinnedDashboard[];
}

export interface IPinnedEntityTab {
  tabName: string;
  index: number;
  tabType: IPinnedEntityEnum;
  id: string;
  icon?: JSX.Element;
  isNotAllowedToView?: boolean;
}

export enum IPinnedTabName {
  HOME = 'Home',
  RECRUITER_ANALYTICS = 'Home',
  REMINDERS = 'Reminders',
}

export const generateTab = (
  tabType: IPinnedEntityEnum,
  tabName: IPinnedTabName
): IPinnedEntityTab => {
  return {
    tabName: tabName,
    index: 0,
    tabType: tabType,
    id: '',
  };
};
